<template>
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 1.25L17.25 9.5L12 17.75" stroke="#A6B7BE" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M17.25 10C17.5261 10 17.75 9.77614 17.75 9.5C17.75 9.22385 17.5261 9 17.25 9L17.25 10ZM0.75 9C0.473858 9 0.25 9.22386 0.25 9.5C0.25 9.77614 0.473858 10 0.75 10L0.75 9ZM17.25 9L0.75 9L0.75 10L17.25 10L17.25 9Z"
      fill="#A6B7BE"
    />
  </svg>
</template>
